import { atom } from 'jotai'
import * as R from 'remeda'

import { exists } from '~/utils'

import { type CountData } from '../utils'

import { dataDisplayTypeAtom, sortValueAtom } from './stateAtoms'

export const sortFunctionAtom = atom((get) => {
  const dataDisplayType = get(dataDisplayTypeAtom)
  const sortValue = get(sortValueAtom)

  return <T extends CountData>(array: T[]) =>
    R.sortBy<T[]>((item) => {
      if (!exists(sortValue)) {
        return 0
      }

      const value =
        dataDisplayType === 'percentage'
          ? item.ratios[sortValue.columnKey]
          : item.counts[sortValue.columnKey]

      return value * (sortValue.ascending ? 1 : -1)
    })(array)
})
